$(document).on('turbolinks:load', function () {
  $('#signup-form').submit(function (e) {
    const response = grecaptcha.getResponse();
    if (!response.length) {
      alert("Please verify you are human");
      e.preventDefault();
      return false;
    }
  })
})